export default __webpack_public_path__ + "static/media/Logo.0f332ead.png";